const closeButtonLabel = "Close";
const enUS = {
  closeButtonLabel
};
export {
  closeButtonLabel,
  enUS as default
};
